import React from 'react';
import { getImagePath } from '../../getImagePath';
import styles from './style.module.scss';

function DonutChart() {
    return (
        <div className={styles.donutChart}>
            <h3>調查項目一覽</h3>
            <img src={getImagePath("/homepage/donut.svg")} alt="donut" />
        </div>
    );
}

export default DonutChart;
